module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it@2-670a4bd6f8eb6d0e3642bcb35ad5e539.jpg";